import { Component } from "@angular/core";

@Component({
  selector: "retired",
  templateUrl: "./retired.component.html",
  styleUrls: ["./retired.component.scss"],
  standalone: false,
})
export class RetiredComponent {}
